import { Component, inject, OnInit } from '@angular/core';
import { EventsListStateService } from '@modules/calendar-app/services/events-list-state.service';
import { EventsService } from '@modules/calendar-app/services/events.service';
import { CalendarEvent } from '@modules/calendar-app/types/calendar-event';
import { EventsFilters } from '@modules/calendar-app/types/events-filters';
import { EventsListState } from '@modules/calendar-app/types/events-list-state';
import { SortOrder } from '@modules/common/types/sort-order';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-events-section',
  templateUrl: './events-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...EventsListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeEventsSectionComponent
  extends KnowledgeStitchSectionComponent<CalendarEvent, EventsFilters>
  implements OnInit
{
  protected readonly listStateService = inject(EventsListStateService, { self: true });
  protected readonly stitchService = inject(EventsService);

  public override ngOnInit(): void {
    this.state = new EventsFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: EventsListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new EventsFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
